/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getInvoiceAttachments } from "api/services/invoice";
import { invoiceQueryKeys } from "./invoiceQueryKeys";

type GetInvoiceAttachmentsOptions = {
  invoiceId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetInvoiceAttachments = (data: GetInvoiceAttachmentsOptions) =>
  useQuery({
    queryKey: invoiceQueryKeys.invoiceAttachmentDetails(data.invoiceId),
    queryFn: data.queryFn
      ? data.queryFn
      : () =>
          getInvoiceAttachments(data.invoiceId)
            .then((res) => res.data)
            .catch((err) => err),
    ...data.options,
  });
